import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import Clipboard from 'clipboard'
import { Toptips, Toast } from 'react-weui'
import { renderMoney, isLZWKAPP, renderPopular, fixBackContentEmpty } from '../../utils'
import { WKSkeletonScreen } from '../../components/wk'
import PublishModal from './ResellPublishModal'
import hotLabelImg from '../../images/resell/hot-label.png'
import '../../css/page/ResellPage.css'

const appInviterId = '44813679'

class ResellStore extends React.Component {
    constructor(props) {
        super(props)
        this.isInitShareInfo = false
        this.state = {
            resells: [],
            isPending: false,
            hasMore: true,
            offset: 0,
            isPublishPending: false,
            isShowModal: false,
            publishData: null,
            resellCenterShareInfo: {},

            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount() {
        this.fetchData()
        fixBackContentEmpty()
    }
    fetchData() {
        this.setState({ isPending: true })
        axios.get('/api/resell/recommend', {
            params: {
                offset: this.state.offset
            }
        })
            .then(res => {
                const data = res.data.data
                this.setState({
                    isPending: false,
                    offset: data.next_offset,
                    hasMore: data.has_more,
                    resells: this.state.resells.concat(data.resells),
                })
                if (!this.isInitShareInfo) {
                    this.setState({ resellCenterShareInfo: data.share_info })
                    this.setShareInfo({
                        title: data.share_info.share_title,
                        desc: data.share_info.share_description,
                        imgUrl: data.share_info.share_icon,
                        link: data.share_info.share_url,
                    })
                    this.isInitShareInfo = true
                }
            })
    }
    onClickPublish (e, type, id) {
        e.stopPropagation()
        this.setState({ isPublishPending: true })
        const inviterId = isLZWKAPP() ? appInviterId : '23526994'
        axios.get(`/api/resell/${type}/${id}/promo_info?st=lzwk_resell&inviter_id=${inviterId}`)
            .then(res => {
                const data = res.data.data
                this.setState({
                    isPublishPending: false,
                    isShowModal: true,
                    publishData: data,
                }, () => this.initCopyboard())
                this.setShareInfo({
                    title: data.share_info.share_title,
                    desc: data.share_info.share_description,
                    imgUrl: data.share_info.share_icon,
                    link: data.share_info.share_url,
                })
            })
    }
    setShareInfo (data) {
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: data,
        })
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    initCopyboard () {
        const clipboard = new Clipboard('#copy-btn')
        clipboard.on('success', (e) => {
            this.showTip('已复制到剪贴板', 'primary')
            e.clearSelection()
        })
    }
    onClickPublishClose () {
        this.setState({ isShowModal: false, publishData: null })
        this.setShareInfo({
            title: this.state.resellCenterShareInfo.share_title,
            desc: this.state.resellCenterShareInfo.share_description,
            imgUrl: this.state.resellCenterShareInfo.share_icon,
            link: this.state.resellCenterShareInfo.share_url,
        })
    }
    // resell_info 优先级选择
    getResellInfo (item) {
        let resellInfo
        if (item.liveroom_resell_info) {
            resellInfo = item.liveroom_resell_info
        } else {
            resellInfo = item.resell_info
        }
        return resellInfo
    }
    onClickItem (type, id) {
        if (isLZWKAPP()) {
            location.assign(`lizhiweike://${type}?${type}_id=${id}&inviter_id=${appInviterId}`)
        } else {
            location.assign(`/${type}/${id}?st=lzwk_resell&inviter_id=23526994`)
        }
    }
    getResellField (item) {
        if (item.liveroom_resell_info) {
            return '预计佣金'
        } else {
            return '预计邀请奖励'
        }
    }
    render() {
        
        return (
            <div>
                <div className="hot">
                    <div className="header">
                        <b>热销课程</b>
                    </div>
                    <div className="hot-list">
                        {
                            this.state.isPending && <WKSkeletonScreen num={3}/>
                        }
                        {
                            this.state.resells.slice(0, 2).map(item => (
                                <div className="hot-item" key={item.object.id} onClick={e => this.onClickItem(item.object.object_type, item.object.id)}>
                                    <div className="cover">
                                        <img src={item.object.cover_url} alt=""/>
                                    </div>
                                    <div className="title text-cut">{item.object.name}</div>
                                    {
                                        item.object.object_type === 'channel' && (
                                            <div className="intro">
                                                <span className='margin-right'>已更新{item.object.stats_info.lecture_count}期</span>
                                                <span>{renderPopular(item.object.stats_info.popular)}人气</span>
                                            </div>
                                        )
                                    }
                                    <div className="money">
                                        ￥ <span className='big'>{renderMoney(item.object.money).split('.')[0]}</span>.{renderMoney(item.object.money).split('.')[1]}
                                    </div>
                                    <div className="hot-label">
                                        <img src={hotLabelImg} alt=""/>
                                    </div>
                                    <div className="earn" onClick={e => this.onClickPublish(e, item.object.object_type, item.object.id)}>
                                        赚¥{renderMoney(item.object.money * this.getResellInfo(item).percent / 100)}
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                <div className="recommend">
                    <div className="header">
                        <b>精品推荐</b>
                    </div>
                    <div className="recommend-list">
                        {
                            this.state.isPending && <WKSkeletonScreen num={2}/>
                        }
                        {
                            this.state.resells.slice(2).map(item => (
                                <div 
                                    className="recommend-item-wrap" 
                                    key={item.object.id}
                                    onClick={e => this.onClickItem(item.object.object_type, item.object.id)}
                                >
                                    <div className="recommend-item">
                                        <div className="cover">
                                            <img src={item.object.cover_url} alt=""/>
                                        </div>
                                        <div className="title text-cut-2">{item.object.name}</div>
                                        <div className="money">
                                            ￥ <span className='big'>{renderMoney(item.object.money).split('.')[0]}</span>.{renderMoney(item.object.money).split('.')[1]}
                                        </div>
                                        {
                                            item.object.object_type === 'channel' && (
                                                <div className="intro">
                                                    <span className='margin-right'>已更新{item.object.stats_info.lecture_count}期</span>
                                                    <span>{renderPopular(item.object.stats_info.popular)}人气</span>
                                                </div>
                                            )
                                        }
                                        <div className="earn" onClick={e => this.onClickPublish(e, item.object.object_type, item.object.id)}>
                                            赚¥{renderMoney(item.object.money * this.getResellInfo(item).percent / 100)}
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                {
                    this.state.publishData && (
                        <PublishModal
                            onClickPublishClose={() => this.onClickPublishClose()}
                            publishData={this.state.publishData}
                        />
                    )
                }
                <Toast icon="loading" show={this.state.isPublishPending}></Toast>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
            
        )
    }
}

export default connect(state => ({
    account: state.account
}))(ResellStore)


// WEBPACK FOOTER //
// ./src/pages/resell/ResellStore.js